import React, { createContext, useState } from 'react';
import { decodeToken, getToken } from '@utils';

export const UserContext = createContext({
  userData: {},
  getUserData: () => {},
  setUserData: data => {},
});

export const UserContextProvider = ({ children }) => {
  const getUserData = () => {
    const accessToken = getToken();
    const user = decodeToken(accessToken);
    user['role'] = localStorage.getItem('role');
    return user;
  };

  const setUserData = async data => {
    userData['userData'] = data;
  };

  const userState = {
    userData: getUserData(),
    getUserData,
    setUserData,
  };

  const [userData] = useState(userState);

  return (
    <UserContext.Provider value={userData}>{children}</UserContext.Provider>
  );
};

export const UserContextConsumer = UserContext.Consumer;
